























// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// models
import { DailyControlTablePreview } from '@/models/dailyControl'

@Component({
  name: 'TableNewDailyControls'
})
export default class TableNewDailyControls extends Vue {
  @Prop({ required: true, type: Array }) items!: DailyControlTablePreview[]
  headers = [
    { key: 'date', label: 'Fecha' },
    { key: 'description', label: 'Descripción' },
    { key: 'price', label: 'Tarifa' },
    { key: 'amount', label: 'Cantidad' },
    { key: 'total', label: 'Importe' },
    { key: 'actions', label: 'Acciones' }
  ]

  removeItem (index: number) {
    this.$emit('remove-item', index)
  }
}
